var map = {
	"./title-carousel.de-CH.json": 1264,
	"./title-carousel.de-DE.json": 1265,
	"./title-carousel.en-CA.json": 1266,
	"./title-carousel.en-GB.json": 1267,
	"./title-carousel.en-IN.json": 1268,
	"./title-carousel.en-ME.json": 1269,
	"./title-carousel.en-US.json": 1270,
	"./title-carousel.es-EM.json": 1271,
	"./title-carousel.es-ES.json": 1272,
	"./title-carousel.fr-BE.json": 1273,
	"./title-carousel.fr-CA.json": 1274,
	"./title-carousel.fr-CH.json": 1275,
	"./title-carousel.nl-BE.json": 1276,
	"./title-carousel.nl-NL.json": 1277,
	"./title-carousel.pl-PL.json": 1278,
	"./title-carousel.pt-BR.json": 1279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;